import { format, isValid, parseISO, startOfDay } from "date-fns";

/** Initial navigation intent, never a serialization of the working draft:
 *  the calendar day cell the session was opened from. It only defaults the
 *  session's Starting date, whatever the number of shorts. */
export type InitialCalendarPlacement = {
  /** Local calendar day. The scheduling workspace supplies the time. */
  day: string;
};

export function parseCalendarPlacementDay(day: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const date = parseISO(day);
  return isValid(date) && format(date, "yyyy-MM-dd") === day ? date : null;
}

export function validateCalendarPlacement(placement: InitialCalendarPlacement, now: number): string | null {
  const day = parseCalendarPlacementDay(placement.day);
  if (!day || day.getTime() < startOfDay(now).getTime()) return "Choose today or a future day.";
  return null;
}
